import { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import TestFilters from "../Category/TestFilters";
import TestCard from "./TestCard"
import PackageCard from "./PackageCard";
import authService from '../../../Services/authService';
import { useCart } from "../../../Services/CartContext";


export default function BookTestsPage() {

  const [individualTests, setIndividualTests] = useState([]);
  const [packagesTests, setPackagesTests] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [individualtestcount, setIndividualtestcount] = useState([]);
  const [packagescount, setPackagescount] = useState([]);

  const [filters, setFilters] = useState({
    types: [], // e.g., ["Single Test", "Packages"]
    priceOrder: "", // e.g., "low_to_high"
    locationOrder:"",
  });

  useEffect(() => {
    applyFilters();
  }, [filters]);


  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  const applyFilters = () => {
    const url = new URL(authService.getApiUrl() + 'filter');
    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify({
        type: filters.types.join(","), // API expects comma-separated string
        priceOrder: filters.priceOrder,
        visit_type:filters.locationOrder
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        setIndividualTests(result.data.labTests || []);
        setPackagesTests(result.data.packages || []);
        //setIndividualtestcount(result.data.labTestsCount || 0);
        //setPackagescount(result.data.packagesCount || 0);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {

    loadTests();
    const user = authService.getCurrentuser();
    if (user) {
      loadCartItems();
    }

  }, []);



  const loadCartItems = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'cartlist');
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
        organization_id: 1
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        const cartItems = result.data;
        setCartItems(cartItems);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };


  const loadTests = () => {
    const url = new URL(authService.getApiUrl() + 'testspackagesdata');
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        // Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
        return res.json();
        //}
      })
      .then((result) => {
        setIndividualTests(result.data.labTests);
        setPackagesTests(result.data.packages);
        setIndividualtestcount(result.data.labTestsCount);
        setPackagescount(result.data.packagesCount);
        //setCartItems(result.data.cartitems); // Set counts to the fetched quantities
        //setOrganizationData(result.data.organization)
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const getQuantityForTest = (testId) => {
    const foundItem = cartItems.find((item) => item.test_id === testId);
    return foundItem ? foundItem.quantity : 0;
  };

  return (
    <>

      {/* Hero Section */}
      <section className="bg-[rgb(149,28,37,0.2)] border-b border-[#E0E0E0]">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
          <div className="flex items-center space-x-2 mb-1">
            <Link to="/" className="text-xs text-[#951C25]/80 hover:text-[#951C25]">
              Home
            </Link>
            <span className="text-[#951C25]/50">/</span>
            <span className="text-xs text-[#951C25]">Book Tests</span>
          </div>

          <h1 className="text-2xl md:text-3xl font-semibold text-[#951C25]">Book Tests & Packages</h1>
          <p className="text-sm text-[#951C25]/80 max-w-2xl">
            Browse our comprehensive range of diagnostic tests and health packages
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-8 md:py-12">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Filters Sidebar */}
            <div className="w-full md:w-64 flex-shrink-0">
              <TestFilters individualTestCount={individualtestcount}
                packagesCount={packagescount}
                onFilterChange={setFilters}
              />
            </div>

            {/* Test Listings */}
            <div className="flex-1">
              {/* Packages Section */}
              <div className="mb-10">
                <h2 className="text-xl font-semibold text-[#4A4A4A] mb-6">Browse Tests / Packages</h2>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {packagesTests.map((test) => (
                    <PackageCard
                      key={test.id}
                      id={test.id}           // ✅ pass real id
                      title={test.package_name}
                      description={test.description}
                      price={test.price}
                      visit_type={test.visit_type}
                      quantity={getQuantityForTest(test.id)}
                      total_tests={test.test_count}
                      mrp_price={test.mrp_price}
                    />
                  ))}
                </div>
                {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {testPackages.map((pkg) => (
                    <PackageCard key={pkg.id} package={pkg} />
                  ))}
                </div> */}
              </div>

              {/* Individual Tests Section */}
              <div>
                <h2 className="text-xl font-semibold text-[#4A4A4A] mb-6">Individual Tests</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4">
                  {individualTests.map((test) => (

                    <TestCard
                      key={test.id}
                      id={test.id}           // ✅ pass real id
                      title={test.test_name}
                      description={test.short_description}
                      price={test.price}
                      visit_type={test.visit_type}
                      quantity={getQuantityForTest(test.id)}
                      category_name={test.category_name}
                      mrp_price={test.mrp_price}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
